import { render } from "./UserBadge.vue?vue&type=template&id=0e68dd3a&scoped=true"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"

import "./UserBadge.vue?vue&type=style&index=0&id=0e68dd3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e68dd3a"

export default script